const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the add avatar component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('addAvatar', ['$translate', function ($translate) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        newImage: '&',
        ispresent: '=ispresent',
        active: '=',
        hideButtons: '@?',
        trigger: '=?'
      },
      template: require('../../templates/directives/avatar-uploader.html'),
      controller: ['$scope', function ($scope) {
        var self = this;
        self.modifiedLink = '';
        self.modifiedId = 'avatar-modify';
        self.uniqueAvatarAdd = 'add-avatar-' + Math.round(Math.random() * 1000);

        if ($scope.hideButtons) {
          $scope.$watch('trigger', function(newVal, oldVal) {
            if (newVal && !oldVal) {
              document.getElementById(self.uniqueAvatarAdd).click();
              $scope.trigger = false;
            }
          });
        }

        self.makeProgress = function(percent) {
          return {
            'width': percent + '%'
          };
        };

        self.updateImage = function(url) {
          $scope.newImage({link: url});
          self.cancelCrop();
        };

        self.progress = function() {
          if (self.percent === null) {
            return 0 + '';
          }
          return self.percent - 100 + '%';
        };

        self.cancelCrop = function() {
          self.loading = false;
          self.percent = null;
          self.apply = false;
          $scope.active = false
        };

        self.crop = function(link) {
          if (!link) {
            return;
          }
          self.updateImage(link);
        };

        // Watches the value passed to the banner Upload
        $scope.$watch('avatar.image', function(newVal, oldVal) {
          if (!newVal || newVal === oldVal) {
            return;
          }
          $scope.active = true;
        });

        $translate(['modules.notifications.profile_updated', 'modules.notifications.canNotUpdateProfile', 'modules.notifications.unableToGetUserTracks', 'manage.users.location', 'manage.users.selectALocation']).then(function(data){
          self.translations = data;
        });
      }],
      controllerAs: 'avatar'
    };
  }]);
